import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectTestSamples } from '@store/partners-order/selectors';
import { setTestSamples } from '@store/partners-order/slice';
import Checkbox from '@components/checkbox/Checkbox';
import { Button } from 'react-aria-components';



const TestSamples = () => {
	const { t } = useTranslation('forms');
	
	const testSamples = useSelector(selectTestSamples);
	const dispatch = useDispatch();
	const updateTestSamples = (value: boolean) => dispatch(setTestSamples(value));
	
	return (
		<div className='component-text-field'>
			<Checkbox isSelected={testSamples} onChange={() => updateTestSamples(!testSamples)}>
			</Checkbox>

			<Button className={`app-form-button disable-selection${testSamples ? ' active' : ''}`} autoFocus={false} onPress={() => updateTestSamples(!testSamples)}>
				{t('sizesUnits.testSamples')}
			</Button>
		</div>
	);
};

export default TestSamples;